"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = exports.Row = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Row = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;

  align-items: center;
  padding: 8px 32px;
  cursor: pointer;

  &:hover {
    background: lightgrey;
  }
`;
exports.Text = styled_components_1.default.div `
  display: flex;
  align-items: center;
  & img {
    border-radius: 50%;
    margin-right: 8px;
    border: 1px solid #F0F0F0;
    object-fit: cover;
  }
`;
//# sourceMappingURL=styled.js.map